import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDocumentPngProps } from './IconDocumentPng.types'
import * as Styled from './styles/IconDocumentPng.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentPng: FC<IconDocumentPngProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentPngProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDocumentPngProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M15.598 13.227h.632v1.23s-1.722.59-1.972-.926c-.25-1.539.73-1.86.922-1.902.117-.027.773-.125.988.367m-8.398 2.57v-2.964h.867s.863-.063.863.867c0 .93-.867.867-.867.867H7.77m3.101 1.234v-2.968l1.98 2.968v-2.968M5.637 6.543H9.5V2.797'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M10.355 2.543a2.15 2.15 0 0 0-1.39.512l-2.703 2.32a2.124 2.124 0 0 0-.742 1.617v12.465c0 1.098.902 2 1.742 2h9.218c1.36 0 2-.902 2-2V2.543Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDocumentPng
